module.exports = __webpack_public_path__ + "static/media/receivership-order-may8-2023.3c55ff4b.pdf";